<h1 i18n>This Candidate's VM is restarting now, this may take a few minutes.</h1>
